const openLineIds = new Set()
// Lines the user manually collapsed while Expand All (or after) — survive virtual remounts
const closedLineIds = new Set()
// Bumped when a shipment is (re)loaded so mounted line items collapse even if
// the same merchandiseIds are reused.
let openStateGeneration = 0

function clearOpenSets() {
  openLineIds.clear()
  closedLineIds.clear()
}

export function getMerchandiseLineOpenStateGeneration() {
  return openStateGeneration
}

export function rememberLineOpen(merchandiseId, open) {
  if (!merchandiseId) return
  if (open) {
    openLineIds.add(merchandiseId)
    closedLineIds.delete(merchandiseId)
  } else {
    openLineIds.delete(merchandiseId)
    closedLineIds.add(merchandiseId)
  }
}

export function isMerchandiseLineOpen(merchandiseId) {
  return !!merchandiseId && openLineIds.has(merchandiseId)
}

export function isMerchandiseLineExplicitlyClosed(merchandiseId) {
  return !!merchandiseId && closedLineIds.has(merchandiseId)
}

/** Clear remembered open/closed lines and notify mounted items to collapse. */
export function clearAllMerchandiseLineOpenState() {
  clearOpenSets()
  openStateGeneration += 1
}

/** @deprecated use clearAllMerchandiseLineOpenState — kept for existing call sites */
export function clearOpenMerchandiseLines() {
  clearAllMerchandiseLineOpenState()
}

export function clearClosedMerchandiseLines() {
  closedLineIds.clear()
}

/** Clear memory without remounting (Collapse All). */
export function forgetAllMerchandiseLineOpenState() {
  clearOpenSets()
}

/**
 * Initial open state for a (re)mounted virtualized line.
 * Explicit user collapse wins over Expand All so scroll-away remount
 * does not reopen a line the user just collapsed.
 */
export function resolveInitialShowLineItem(merchandiseId, expandAllLines) {
  if (isMerchandiseLineExplicitlyClosed(merchandiseId)) {
    return false
  }
  if (isMerchandiseLineOpen(merchandiseId)) {
    return true
  }
  if (expandAllLines) {
    rememberLineOpen(merchandiseId, true)
    return true
  }
  return false
}
